var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit16Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.599976 7.56703V9.4001H2.43305L7.83937 3.99372L6.00632 2.16065L0.599976 7.56703ZM9.257 2.57615C9.44763 2.38551 9.44763 2.07755 9.257 1.88691L8.11316 0.743077C7.92252 0.552438 7.61456 0.552438 7.42392 0.743077L6.52938 1.63762L8.36246 3.47069L9.257 2.57615Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit16Icon);
export default __webpack_public_path__ + "static/media/edit_16_icon.eeb4641e7e6351204f996ab7397d951b.svg";
export { ForwardRef as ReactComponent };